<template>
  <div
    :class="getItemStyleClass"
    @click="itemClick(item)"
    class="appointment-schedule-date-item"
  >
    {{ item.appointmentDate.replace(/(.{4})(.{2})(.{2})/, "$2.$3") }}
    {{ item.timeFrameCode }}
    <span
      v-if="item.workState === '1'"
      class="appointment-schedule-date-item-stop-tip"
      >停</span
    >
    <span v-else>(剩{{ item.remain }})</span>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showPopupWindow: false,
      numberList: []
    };
  },
  computed: {
    getItemStyleClass() {
      if (this.item.workState === "1") {
        return "appointment-schedule-date-item-stop";
      }
      if (this.item.remain === "0") {
        return "appointment-schedule-date-item-empty";
      }
      return "";
    }
  },
  methods: {
    itemClick(item) {
      this.$emit("click", item);
    }
  }
};
</script>

<style lang="less" scoped>
.appointment-schedule-date-item {
  width: calc(50% - 1.3rem);
  margin: 0.2rem 0.5rem;
  color: #fff;
  font-size: 0.82rem;
  line-height: 1.6rem;
  text-align: center;
  background-color: #6596f2;
  border: 0.1rem solid #6596f2;
  border-radius: 5px;

  &-stop-tip {
    float: right;
    padding: 0 0.3rem;
    color: white;
    background: rgba(255, 0, 0, 0.452);
  }
}
.appointment-schedule-date-item-empty {
  background: #c1bfb7;
  border-color: #c1bfb7;
}
.appointment-schedule-date-item-stop {
  color: rgba(255, 0, 0, 0.452);
  background-color: white;
  border-color: rgba(255, 0, 0, 0.452);
}
</style>
